import React, { useState } from 'react';
import './Workshops.css';
import workshopsData from '../data/workshops.json';
import { useContent } from '../contexts/ContentContext';

type WorkshopItem = {
  id: string;
  title: string;
  description: string;
  icon: string;
  featured: boolean;
  registrationLink?: string;
};

const Workshops = () => {
  const { getSection } = useContent();
  const data = getSection<typeof workshopsData>('workshops', workshopsData);
  const workshops = data.workshops as WorkshopItem[];
  const [expandedWorkshopId, setExpandedWorkshopId] = useState(null);

  const handleLearnMore = (workshopId) => {
    setExpandedWorkshopId(currentWorkshopId => (
      currentWorkshopId === workshopId ? null : workshopId
    ));
  };

  return (
    <section id="workshops" className="workshops-section">
      <div className="workshops-container">
        <div className="section-header">
          <h2 className="section-title">Skill Development Workshops</h2>
          <p className="section-subtitle">
            Enhance your technical skills with our comprehensive workshop programs at ASIMO Technical Club
          </p>
        </div>

        <div className="workshops-grid">
          {workshops.map((workshop, index) => (
            <div key={workshop.id} className={`workshop-card workshop-${index + 1} ${workshop.featured ? 'featured' : ''}`}>
              <div className="workshop-header">
                <div className="workshop-icon">
                  <i className={workshop.icon}></i>
                </div>
                {workshop.featured && (
                  <div className="featured-badge">Featured</div>
                )}
              </div>
              
              <h3 className="workshop-title">{workshop.title}</h3>
              {expandedWorkshopId === workshop.id && (
                <p className="workshop-description">{workshop.description}</p>
              )}
              
              <div className="workshop-actions">
                <button
                  className="btn-info"
                  onClick={() => handleLearnMore(workshop.id)}
                >
                  Learn More
                </button>
                {workshop.registrationLink ? (
                  <a
                    className="btn-register"
                    href={workshop.registrationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Register
                  </a>
                ) : (
                  <button className="btn-register btn-closed" disabled>
                    registration over
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="workshops-cta">
          <h3>Ready to Level Up Your Skills?</h3>
          <p>Join our ASIMO Technical Club workshops and learn cutting-edge technologies.</p>
        </div>
      </div>
    </section>
  );
};

export default Workshops;